const contactos = [
  { icon: "📞", label: "72 2 226550", href: "tel:722226550", style: "bg-white/10 border-white/10 text-white" },
  { icon: "💬", label: "WhatsApp +56 9 42771012", href: "https://wa.me/56942771012", style: "bg-green-500/15 border-green-400/30 text-green-300" },
  { icon: "✉", label: "dentistacontralor@gmail.com", href: "mailto:dentistacontralor@gmail.com", style: "bg-codelco/15 border-codelco/30 text-codelco-light" },
];

export default function Contacto({ onNav }) {
  return (
    <footer className="bg-navy-600 mx-6 md:mx-8 mb-8 rounded-2xl p-5 md:p-6 max-w-5xl md:mx-auto">
      <div className="flex flex-col md:flex-row md:items-center gap-4">
        <div className="flex-1">
          <p className="text-white font-semibold text-sm mb-0.5">
            Contacta al Dentista Contralor
          </p>
          <p className="text-white/50 text-xs">
            Dr. Carlos Eduardo Soto Pérez · Av. Miguel Ramírez #140, frente a Isapre Colmena, Rancagua
          </p>
          <button
            onClick={() => onNav?.("privacidad")}
            className="mt-3 text-codelco-light text-xs font-medium hover:underline"
          >
            Ver Política de Privacidad
          </button>
        </div>
        <div className="flex flex-wrap gap-2">
          {contactos.map((c) => (
            <a
              key={c.label}
              href={c.href}
              target={c.href.startsWith("http") ? "_blank" : undefined}
              rel="noreferrer"
              className={`flex items-center gap-2 border rounded-lg px-3 py-2 text-xs font-medium hover:opacity-80 transition-opacity ${c.style}`}
            >
              <span>{c.icon}</span>
              {c.label}
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
}
